<!-- @format -->

<register-complete-modal>
  <div class="modal js-modal" is="modal-base" is-open="{ props.isOpen }">
    <div class="modal__bg js-modal-close" onclick="{ props.onClose }"></div>
    <div class="modal__content">
      <div class="modal__content_inner">
        <p class="align-c">登録が完了しました。</p>
        <div class="container_button">
          <buton
            class="button button-primary button-primary-mini"
            onclick="{ props.onClose }"
          >
            閉じる
          </buton>
        </div>
        <!--/.container_button-->
      </div>
      <!--/.modal__content_inner-->
      <a class="btn_close_modal js-modal-close" onclick="{ props.onClose }"></a>
    </div>
    <!--modal__content-->
  </div>
  <!--modal-->

  <script>
    import base from "../modal-base.riot";

    export default {
      components: {
        "modal-base": base,
      },
    };
  </script>
</register-complete-modal>
